import React, { useEffect, useState } from "react"
import Calendar from "../../../../../components/atoms/Calendar.atom"
import { capitalizeFirstLetter } from "../../../../../utils/strings.utils"
import PrimaryButton from "../../../../../components/molecules/buttons/PrimaryButton.molecule"
import useTimeRegisterContext from "../../../hooks/useTimeRegisterContext.hook"
import UnifiedDatePicker from "../../../../../components/compounds/UnifiedDatePicker.compound"
import {getModifiedDateTime, isSameDay} from "../../../../../utils/dateTime.utils"

/** @type {import("./DatePicker.d")["default"]} */
const DatePicker = ({ selectedDate, setSelectedDate, uncompleteDay }) => {
  const { editingMissingDay } = useTimeRegisterContext()
  const todayDate = getModifiedDateTime({atNoon: true}).toJSDate()
  const selectedDateIsToday = isSameDay(selectedDate, todayDate)

  return (
    <div className="flex gap-3" style={{ height: "38px" }}>
      <PrimaryButton
        disabled={
          selectedDateIsToday ||
          Boolean(uncompleteDay) ||
          Boolean(editingMissingDay)
        }
        label="Hoy"
        onClick={() => {
          setSelectedDate(todayDate)
        }}
      />
      <div className="relative">
        <UnifiedDatePicker
          disabled={editingMissingDay || uncompleteDay}
          readOnly={editingMissingDay || uncompleteDay}
          className="cursor-pointer time-register-date-picker"
          dateRange={[
            getModifiedDateTime({dateTime: selectedDate, atNoon: true}),
            getModifiedDateTime({dateTime: selectedDate, atNoon: true})
          ]}
          setDateRange={(e) => {
            setSelectedDate(e[0].startOf("day").toJSDate())
          }}
          disabledDate={(current) => {
            return current && current > getModifiedDateTime({endOf: "day"})
          }}
          disabledRightChevron={selectedDateIsToday}
        />
      </div>
    </div>
  )
}

export default DatePicker
